import type { UseQueryResult } from '@tanstack/react-query'
import { Board, BoardSkeleton, type BoardProps } from './board'
import { ViewError } from '@/components/common/query-states'

/**
 * The loading / error / board ternary that every kanban route repeated.
 * `query` drives the state; `errorWhat`/`skeletonColumns` tune the messaging.
 */
export function BoardView({
  query,
  errorWhat = 'issues',
  skeletonColumns,
  ...board
}: BoardProps & {
  query: Pick<UseQueryResult, 'isPending' | 'isError' | 'refetch' | 'error'>
  errorWhat?: string
  skeletonColumns: number
}) {
  if (query.isError) return <ViewError what={errorWhat} error={query.error} onRetry={() => query.refetch()} />
  if (query.isPending) return <BoardSkeleton columns={skeletonColumns} />
  return <Board {...board} />
}
